export class ApartmentInfoStorageSerializer {
    serializeForStorage(data) {
        return JSON.stringify(data);
    }
    deserializeFromStorage(data) {
        try {
            const info = JSON.parse(data);
            this.assertValid(info);
            return info;
        }
        catch (error) {
            return null;
        }
    }
    assertValid(data) {
        if (typeof data !== "object" ||
            data === null ||
            !("type" in data) ||
            !("floor" in data) ||
            !("aptNumber" in data)) {
            throw new Error("Invalid apartment info data");
        }
    }
}
